module.exports = __webpack_public_path__ + "e9c782442042911f345358d42f41e6f2.glb";